import React, { createContext, useState } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // const DEFAULT_LICENSE_DATE = "2025-11-24"; // fallback value

  const [userId, setUserId] = useState(localStorage.getItem('userId') || null);
  const [firstName, setFirstName] = useState(localStorage.getItem('firstName') || null);
  const [lastName, setLastName] = useState(localStorage.getItem('lastName') || null);
  const [userName, setUserName] = useState(localStorage.getItem('userName') || null);
  const [userEmail, setUserEmail] = useState(localStorage.getItem('userEmail') || null);
  const [userMobile, setUserMobile] = useState(localStorage.getItem('userMobile') || null);
  const [isAdmin, setIsAdmin] = useState(localStorage.getItem('isAdmin') || null);
  const [bank, setBank] = useState(localStorage.getItem('bank') || null);
  const [agentPrinterCode, setAgentPrinterCode] = useState(localStorage.getItem('agentPrinterCode') || null);

  const [subscriptionPeriod, setSubscriptionPeriod] = useState(
    localStorage.getItem('subscriptionPeriod') || null
  );
 const [licenseEndDate, setLicenseEndDate] = useState(
    localStorage.getItem('licenseEndDate') || null
  );

  const login = (user) => {
    setUserId(user.id);
    setFirstName(user.first_name);
    setLastName(user.last_name);
    setUserName(user.username);
    setUserEmail(user.email);
    setUserMobile(user.mobile);
    setIsAdmin(user.is_admin);
    setBank(user.bank);
    setAgentPrinterCode(user.agentPrinterCode);

    setSubscriptionPeriod(user.subscription_period);
 setLicenseEndDate(user.license_end_date); 
    // If license_end_date is null → use default 24/11/2022
    // const finalLicenseDate =
    //   user.license_end_date === null || user.license_end_date === "null"
    //     ? DEFAULT_LICENSE_DATE
    //     : user.license_end_date;

    // setLicenseEndDate(finalLicenseDate);

    localStorage.setItem('userId', user.id);
    localStorage.setItem('firstName', user.first_name);
    localStorage.setItem('lastName', user.last_name);
    localStorage.setItem('userName', user.username);
    localStorage.setItem('userEmail', user.email);
    localStorage.setItem('userMobile', user.mobile);
    localStorage.setItem('isAdmin', user.is_admin);
    localStorage.setItem('bank', user.bank);
    localStorage.setItem('agentPrinterCode', user.agentPrinterCode);

    localStorage.setItem('subscriptionPeriod', user.subscription_period);
    localStorage.setItem('licenseEndDate', user.license_end_date);
  };

  const logout = () => {
    setUserId(null);
    setFirstName(null);
    setLastName(null);
    setUserName(null);
    setUserEmail(null);
    setUserMobile(null);
    setIsAdmin(null);
    setBank(null);
    setAgentPrinterCode(null);
    setSubscriptionPeriod(null);

    // Reset license date also
    setLicenseEndDate(null);

    localStorage.removeItem('userId');
    localStorage.removeItem('firstName');
    localStorage.removeItem('lastName');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userMobile');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('bank');
    localStorage.removeItem('agentPrinterCode');
    localStorage.removeItem('subscriptionPeriod');
    localStorage.removeItem('licenseEndDate');
  };

  return (
    <AuthContext.Provider
      value={{
        userId,
        firstName,
        lastName,
        userName,
        userEmail,
        userMobile,
        isAdmin,
        bank,
        agentPrinterCode,
        subscriptionPeriod,
        licenseEndDate,
        login,
        logout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
